import dev from './app.config.dev';
import type { AppConfig } from './app.config';

export const assistantNativePilotConfig: AppConfig = {
  ...dev,
  ENV: 'assistant-native-pilot',
  API_ENDPOINT: 'http://127.0.0.1:3192',
  NOTIFIER_ENDPOINT: 'http://127.0.0.1:3192',
  APP_ENDPOINT: 'http://127.0.0.1:3193',
  PRICING_PAGE: 'http://127.0.0.1:3193',
  VZNLYTICS_ENDPOINT: '',
  GTM_ID: '',
  GA_ID: '',
  FB_PIXEL_ID: '',
  TIKTOK_ID: '',
  CLARITY_ID: '',
  CRISP_ID: '',
  AW_ID: '',
  WS_ID: '',
  HJ_ID: 0,
  HJ_SV: 0,
};

export function isAssistantNativePilot(environment: string | undefined): boolean {
  return environment === 'assistant-native-pilot';
}

export default assistantNativePilotConfig;
